import React, { useState, useEffect } from "react";
import {
  PdfLoader,
  PdfHighlighter,
  Tip,
  Highlight,
  Popup,
  AreaHighlight,
} from "react-pdf-highlighter";
import { toast } from "react-toastify";
import api from "../../services/api";
import { useAuth } from "../../context/auth";
import * as S from "./styled";

// Componente Tip customizado para alterar o texto
const CustomTip = ({ onOpen, onConfirm, onCancel, competenciaAtiva, onCompetenciaChange }) => {
  const [comment, setComment] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCompetencia, setSelectedCompetencia] = useState(competenciaAtiva);

  // Lista de competências disponíveis
  const competencias = [
    { key: 'adequacao_tema', label: 'Adequação ao Tema', icon: 'fas fa-bullseye', color: '#ff6b6b' },
    { key: 'tipo_texto', label: 'Tipo de Texto', icon: 'fas fa-file-alt', color: '#4ecdc4' },
    { key: 'argumentacao', label: 'Argumentação', icon: 'fas fa-comments', color: '#45b7d1' },
    { key: 'periodo_coesao', label: 'Período/Coesão', icon: 'fas fa-link', color: '#96ceb4' },
    { key: 'modalidade', label: 'Modalidade', icon: 'fas fa-pen', color: '#feca57' }
  ];

  React.useEffect(() => {
    if (onOpen) {
      onOpen();
      setIsOpen(true);
      setSelectedCompetencia(competenciaAtiva);
    }
  }, [onOpen, competenciaAtiva]);

  const handleConfirm = () => {
    // Atualizar a competência ativa se foi alterada
    if (selectedCompetencia !== competenciaAtiva && onCompetenciaChange) {
      onCompetenciaChange(selectedCompetencia);
    }
    // Passar tanto o comentário quanto a competência selecionada
    onConfirm(comment, selectedCompetencia);
    setComment("");
    setIsOpen(false);
  };

  const handleCancel = () => {
    setComment("");
    setSelectedCompetencia(competenciaAtiva); // Resetar para a competência original
    setIsOpen(false);
    if (onCancel) {
      onCancel();
    }
  };

  const handleCompetenciaSelect = (competenciaKey) => {
    setSelectedCompetencia(competenciaKey);
  };

  const selectedComp = competencias.find(c => c.key === selectedCompetencia);

  return (
    <div className="PdfHighlighter__tip" style={{ minWidth: '320px' }}>
      <div style={{ marginBottom: '12px', fontSize: '14px', fontWeight: '600', color: '#495057' }}>
        Adicionar comentário
      </div>
      
      {/* Seletor de Competência */}
      <div style={{ marginBottom: '12px' }}>
        <div style={{ fontSize: '12px', fontWeight: '600', color: '#495057', marginBottom: '6px' }}>
          <i className="fas fa-clipboard-check" style={{ marginRight: '4px' }}></i>
          Competência:
        </div>
        <div style={{ 
          border: '1px solid #ddd', 
          borderRadius: '4px', 
          padding: '6px',
          backgroundColor: '#f8f9fa'
        }}>
          {selectedComp && (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              padding: '4px 8px',
              backgroundColor: selectedComp.color,
              color: 'white',
              borderRadius: '3px',
              fontSize: '12px',
              fontWeight: '500',
              marginBottom: '6px'
            }}>
              <i className={selectedComp.icon} style={{ marginRight: '6px' }}></i>
              {selectedComp.label}
            </div>
          )}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2px' }}>
            {competencias.map((comp) => (
              <button
                key={comp.key}
                type="button"
                onClick={() => handleCompetenciaSelect(comp.key)}
                style={{
                  border: 'none',
                  borderRadius: '2px',
                  padding: '2px 6px',
                  fontSize: '10px',
                  cursor: 'pointer',
                  backgroundColor: selectedCompetencia === comp.key ? comp.color : '#e9ecef',
                  color: selectedCompetencia === comp.key ? 'white' : '#495057',
                  transition: 'all 0.2s ease'
                }}
                title={comp.label}
              >
                <i className={comp.icon}></i>
              </button>
            ))}
          </div>
        </div>
      </div>

      <textarea
        placeholder="Digite seu comentário..."
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && e.ctrlKey) {
            e.preventDefault()
            handleConfirm();
          } else if (e.key === 'Escape') {
            e.preventDefault()
            handleCancel();
          }
        }}
        autoFocus
        rows={3}
        style={{
          width: '100%',
          minHeight: '60px',
          maxHeight: '150px',
          resize: 'vertical',
          border: '1px solid #ddd',
          borderRadius: '4px',
          padding: '8px 12px',
          fontSize: '14px',
          fontFamily: 'inherit',
          lineHeight: '1.4',
          outline: 'none',
          transition: 'border-color 0.2s ease',
        }}
        onFocus={(e) => {
          e.target.style.borderColor = '#007bff';
          e.target.style.boxShadow = '0 0 0 2px rgba(0, 123, 255, 0.25)';
        }}
        onBlur={(e) => {
          e.target.style.borderColor = '#ddd';
          e.target.style.boxShadow = 'none';
        }}
      />
      <div style={{ marginTop: '8px', fontSize: '12px', color: '#6c757d', marginBottom: '8px' }}>
        Pressione Ctrl+Enter para confirmar ou Escape para cancelar
      </div>
      <div style={{ marginTop: '8px' }}>
        <button 
          onClick={handleConfirm} 
          style={{ 
            marginRight: '5px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '6px 12px',
            cursor: 'pointer'
          }}
        >
          Confirmar
        </button>
        <button 
          onClick={handleCancel} 
          style={{ 
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '6px 12px',
            cursor: 'pointer'
          }}
        >
          Cancelar
        </button>
      </div>
    </div>
  );
};

// Mapeamento de competências para códigos de 1 caractere (para banco varchar(1))
const COMPETENCIA_TO_CODE = {
  "adequacao_tema": "a",
  "tipo_texto": "t", 
  "argumentacao": "r",
  "periodo_coesao": "p",
  "modalidade": "m"
};

// Mapeamento reverso: código para competência
const CODE_TO_COMPETENCIA = {
  "a": "adequacao_tema",
  "t": "tipo_texto",
  "r": "argumentacao", 
  "p": "periodo_coesao",
  "m": "modalidade"
};

const CarregarPDFUERJ = React.forwardRef(({ 
  redacaoId, 
  pdfUrl, 
  onHighlightAdd, 
  onHighlightUpdate, 
  onHighlightDelete,
  onHighlightSave,
  competenciaAtiva = "adequacao_tema",
  onCompetenciaChange,
  readOnly = false,
  onHighlightMarkDelete,
  onHighlightCancelDelete
}, ref) => {
  const [highlights, setHighlights] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const { user } = useAuth();

  // Debug: Monitorar mudanças na competenciaAtiva
  useEffect(() => {
    console.log("🎯 CompetenciaAtiva mudou para:", competenciaAtiva);
  }, [competenciaAtiva]);

  // Carregar marcações existentes
  useEffect(() => {
    console.log("🔍 CarregarPDFUERJ - useEffect executado", { redacaoId, pdfUrl });
    if (redacaoId) {
      carregarMarcacoes();
    } else {
      setLoading(false);
    }
  }, [redacaoId]);

  const carregarMarcacoes = async () => {
    try {
      console.log("📥 Carregando marcações para redação:", redacaoId);
      setLoading(true);
      const response = await api.get(`/marcacao/${redacaoId}`);
      console.log("📊 Resposta da API marcações:", response.data);
      
      // Ajustar para trabalhar com a estrutura response.data.data do backend
      const marcacoes = response.data.data || response.data || [];
      
      if (marcacoes && marcacoes.length > 0) {
        const marcacoesFormatadas = marcacoes.map(marcacao => {
          // Parse do conteúdo JSON para extrair dados salvos
          let conteudoParsed = null;
          try {
            conteudoParsed = marcacao.conteudo ? JSON.parse(marcacao.conteudo) : null;
          } catch (error) {
            console.warn("Erro ao fazer parse do conteúdo JSON:", error);
          }

          // Converter código de 1 caractere para nome completo da competência
          let competenciaCompleta = "adequacao_tema"; // fallback padrão
          
          // Primeiro, tentar obter do JSON (nome completo)
          if (conteudoParsed?.competencia) {
            competenciaCompleta = conteudoParsed.competencia;
          } 
          // Se não encontrar no JSON, converter do código de 1 caractere
          else if (marcacao.competencia && CODE_TO_COMPETENCIA[marcacao.competencia]) {
            competenciaCompleta = CODE_TO_COMPETENCIA[marcacao.competencia];
            console.log(`Convertendo código '${marcacao.competencia}' para '${competenciaCompleta}'`);
          }

          return {
            id: marcacao.id_marcacao || marcacao.id || `highlight-${Date.now()}-${Math.random()}`,
            id_marcacao: marcacao.id_marcacao, // ✅ id do backend para sincronização com pai
            content: {
              text: marcacao.comment || "",
              image: marcacao.image_url || conteudoParsed?.content?.image || null
            },
            position: {
              boundingRect: {
                x1: marcacao.x1 || conteudoParsed?.position?.boundingRect?.x1 || 0,
                y1: marcacao.y1 || conteudoParsed?.position?.boundingRect?.y1 || 0,
                x2: marcacao.x2 || conteudoParsed?.position?.boundingRect?.x2 || 0,
                y2: marcacao.y2 || conteudoParsed?.position?.boundingRect?.y2 || 0,
                width: marcacao.width || conteudoParsed?.position?.boundingRect?.width || 0,
                height: marcacao.height || conteudoParsed?.position?.boundingRect?.height || 0,
                pageNumber: marcacao.b_rect_page_number || marcacao.page_number || conteudoParsed?.position?.boundingRect?.pageNumber || 1
              },
              rects: [{
                x1: marcacao.x1 || conteudoParsed?.position?.boundingRect?.x1 || 0,
                y1: marcacao.y1 || conteudoParsed?.position?.boundingRect?.y1 || 0,
                x2: marcacao.x2 || conteudoParsed?.position?.boundingRect?.x2 || 0,
                y2: marcacao.y2 || conteudoParsed?.position?.boundingRect?.y2 || 0,
                width: marcacao.width || conteudoParsed?.position?.boundingRect?.width || 0,
                height: marcacao.height || conteudoParsed?.position?.boundingRect?.height || 0,
                pageNumber: marcacao.b_rect_page_number || marcacao.page_number || conteudoParsed?.position?.pageNumber || 1
              }],
              pageNumber: marcacao.b_rect_page_number || marcacao.page_number || conteudoParsed?.position?.pageNumber || 1
            },
            comment: typeof marcacao.comment === 'string' ? marcacao.comment : (marcacao.comment?.text || conteudoParsed?.comment?.text || ""),
            competencia: competenciaCompleta, // Usar competência convertida
            saved: true // ✅ Marcações do banco já estão salvas
          };
        });
        console.log("Marcações formatadas:", marcacoesFormatadas);
        console.log("IDs de marcação recuperados:", marcacoesFormatadas.map(m => ({ id: m.id, id_marcacao: m.id_marcacao })));
        setHighlights(marcacoesFormatadas);
      } else {
        console.log("Nenhuma marcação encontrada");
        setHighlights([]);
      }
    } catch (error) {
      console.error("❌ Erro ao carregar marcações:", error);
      if (error.response?.status === 404) {
        console.log("ℹ️ Endpoint de marcações não encontrado, continuando sem marcações");
        setHighlights([]);
      } else {
        toast.error("Erro ao carregar marcações existentes");
      }
    } finally {
      console.log("🏁 Finalizando carregamento de marcações");
      setLoading(false);
    }
  };

  const getEmojiByCompetencia = (competencia) => {
    const emojis = {
      adequacao_tema: "📝",
      tipo_texto: "📄",
      argumentacao: "💭",
      periodo_coesao: "🔗",
      modalidade: "✍️"
    };
    return emojis[competencia] || "📝";
  };

  const getColorByCompetencia = (competencia) => {
    const colors = {
      adequacao_tema: "#ff6b6b",
      tipo_texto: "#4ecdc4",
      argumentacao: "#45b7d1",
      periodo_coesao: "#96ceb4",
      modalidade: "#feca57"
    };
    return colors[competencia] || "#ff6b6b";
  };

  // Ref para sempre ter o valor mais atual da competência
  const competenciaAtivaRef = React.useRef(competenciaAtiva);
  
  // Atualizar ref sempre que a prop mudar
  React.useEffect(() => {
    competenciaAtivaRef.current = competenciaAtiva;
    console.log("🔄 CompetenciaAtiva atualizada no ref:", competenciaAtiva);
  }, [competenciaAtiva]);

  // Função para forçar recalculação das posições das marcações
  const recalculateHighlightPositions = (highlightsList) => {
    return highlightsList.map((highlight, index) => {
      // Força uma pequena atualização na posição para trigger re-render
      if (highlight.position && highlight.position.boundingRect) {
        return {
          ...highlight,
          position: {
            ...highlight.position,
            boundingRect: {
              ...highlight.position.boundingRect,
              // Adiciona um offset mínimo para forçar recalculação
              top: highlight.position.boundingRect.top + (index * 0.001)
            }
          }
        };
      }
      return highlight;
    });
  };

  const addHighlight = React.useCallback((highlight) => {
    // ABORDAGEM SIMPLES: Salvar exatamente como recebemos, sem conversões
    // O react-pdf-highlighter já lida com responsividade internamente
    
    // IMPORTANTE: Como estamos ajustando a posição no onSelectionFinished,
    // aqui já recebemos a posição corrigida com o scroll offset
    console.log('💾 Salvando highlight (já com correção de scroll):', highlight);
    
    // Usar a competência passada no highlight ou fallback para a competência ativa
    const competenciaParaUsar = highlight.competencia || competenciaAtivaRef.current;
    
    const newHighlight = {
      ...highlight,
      id: `highlight_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      competencia: competenciaParaUsar,
      timestamp: new Date().toISOString(),
      // Marcar como nova correção sem mexer nas coordenadas
      novoSistema: true,
      comment: typeof highlight.comment === 'string' ? highlight.comment : (highlight.comment?.text || ""),
      saved: false // Marca como não salva
    };
    
    console.log("✅ Nova marcação criada:", newHighlight);
    
    setHighlights(prev => {
      const updated = [...prev, newHighlight];
      console.log("📝 Total de marcações:", updated.length);
      return updated;
    });
    
    // Callback para componente pai
    if (onHighlightAdd) {
      onHighlightAdd(newHighlight);
    }
    
    toast.success(`Marcação adicionada para ${competenciaParaUsar.replace('_', ' ')}`);
  }, [onHighlightAdd]); // Removendo competenciaAtiva das dependências pois usamos ref

  // Função para salvar todas as marcações não salvas
  const saveAllHighlights = async () => {
    const unsavedHighlights = highlights.filter(h => !h.saved && !h.deleted); // Excluir marcações deletadas
    const deletedHighlights = highlights.filter(h => h.deleted);
    
    if (unsavedHighlights.length === 0 && deletedHighlights.length === 0) {
      toast.info("Não há marcações para salvar ou deletar.");
      return;
    }

    setSaving(true);
    let savedCount = 0;
    let deletedCount = 0;
    let errorCount = 0;
    const savedHighlightIds = [];
    const deletedHighlightIds = [];

    try {
      // Processar marcações deletadas primeiro
      for (const highlight of deletedHighlights) {
        try {
          console.log("🗑️ Processando deleção da marcação:", highlight.id);
          console.log("🔍 DEBUG - Dados da marcação para deleção:", {
            id: highlight.id,
            id_marcacao: highlight.id_marcacao,
            saved: highlight.saved,
            deleted: highlight.deleted
          });
          
          // Se a marcação tem id_marcacao (foi salva no banco), fazer chamada para API
          if (highlight.id_marcacao) {
            console.log("🌐 Fazendo chamada para API para deletar marcação do banco...");
            
            try {
              const response = await api.put(`/deletar-correcao/${highlight.id_marcacao}`);
              console.log("✅ Resposta da API de exclusão:", response.data);
              deletedCount++;
            } catch (apiError) {
              console.error("❌ Erro na API ao deletar marcação:", apiError);
              
              // Verificar se é erro 404 (marcação não encontrada no servidor)
              if (apiError.response?.status === 404) {
                console.warn("⚠️ Marcação não encontrada no servidor, removendo apenas localmente");
                deletedCount++;
              } else {
                // Para outros erros, contar como erro
                console.error("❌ Erro ao deletar marcação do servidor:", apiError);
                errorCount++;
                continue; // Pular para próxima marcação
              }
            }
          } else {
            console.log("ℹ️ Marcação não salva no banco, removendo apenas localmente");
            deletedCount++;
          }
          
          // Adicionar à lista de IDs deletados com sucesso
          deletedHighlightIds.push(highlight.id);
          
        } catch (error) {
          console.error(`Erro ao deletar marcação ${highlight.id}:`, error);
          errorCount++;
        }
      }

      // Processar marcações para salvar
      for (const highlight of unsavedHighlights) {
        try {
          // Usar a ref para garantir o valor mais atual da competência
          const competenciaAtual = competenciaAtivaRef.current;
          const competenciaCompleta = highlight.competencia || competenciaAtual;
          const competenciaCodigo = COMPETENCIA_TO_CODE[competenciaCompleta];
          
          // Debug logs para identificar o problema
          console.log("🔍 DEBUG - Salvando marcação:");
          console.log("  - highlight.competencia:", highlight.competencia);
          console.log("  - competenciaAtiva prop:", competenciaAtiva);
          console.log("  - competenciaAtual ref:", competenciaAtual);
          console.log("  - competenciaCompleta:", competenciaCompleta);
          console.log("  - competenciaCodigo:", competenciaCodigo);
          console.log("  - COMPETENCIA_TO_CODE:", COMPETENCIA_TO_CODE);
          
          // Log específico para debug do problema
          if (competenciaCompleta === "adequacao_tema") {
            console.log("🎯 ADEQUAÇÃO TEMA - Código esperado: 'a', Código obtido:", competenciaCodigo);
          }
          if (competenciaCompleta === "argumentacao") {
            console.log("🎯 ARGUMENTAÇÃO - Código esperado: 'r', Código obtido:", competenciaCodigo);
          }
          
          // Verificar se o mapeamento foi encontrado
          if (!competenciaCodigo) {
            console.error("❌ ERRO: Competência não encontrada no mapeamento!", competenciaCompleta);
            throw new Error(`Competência '${competenciaCompleta}' não encontrada no mapeamento`);
          }
          
          // Preparar dados para envio conforme documentação da API
          const marcacaoData = {
            redacao_id: redacaoId,
            competencia: competenciaCodigo, // Salvar código de 1 caractere no campo competencia
            conteudo: JSON.stringify({
              content: {
                image: highlight.content?.image || ""
              },
              position: {
                boundingRect: {
                  x1: highlight.position?.boundingRect?.x1 || 0,
                  y1: highlight.position?.boundingRect?.y1 || 0,
                  x2: highlight.position?.boundingRect?.x2 || 0,
                  y2: highlight.position?.boundingRect?.y2 || 0,
                  width: highlight.position?.boundingRect?.width || 0,
                  height: highlight.position?.boundingRect?.height || 0,
                  pageNumber: highlight.position?.boundingRect?.pageNumber || 1
                },
                pageNumber: highlight.position?.pageNumber || 1
              },
              comment: {
                text: highlight.comment || ""
              },
              competencia: competenciaCodigo // ✅ CORRIGIDO: Usar código ao invés do nome completo
            })
          };

          // Debug: Log dos dados sendo enviados
          console.log('🚀 DADOS SENDO ENVIADOS PARA API:');
          console.log('  - marcacaoData completo:', marcacaoData);
          console.log('  - Campo competencia na requisição:', marcacaoData.competencia);
          console.log('  - Tipo do campo competencia:', typeof marcacaoData.competencia);
          console.log('Competência completa:', competenciaCompleta, '-> Código:', competenciaCodigo);
          console.log('Conteúdo JSON:', JSON.parse(marcacaoData.conteudo));
          
          // Log crítico para debug
          console.log('🔥 VERIFICAÇÃO FINAL ANTES DO ENVIO:');
          console.log('  - competenciaCodigo variável:', competenciaCodigo);
          console.log('  - marcacaoData.competencia:', marcacaoData.competencia);
          console.log('  - São iguais?', competenciaCodigo === marcacaoData.competencia);

          // Enviar para API
          console.log('🌐 FAZENDO REQUISIÇÃO HTTP...');
          console.log('🔍 PAYLOAD FINAL SENDO ENVIADO:');
          console.log('  - URL:', '/correcao/marcacao');
          console.log('  - Method:', 'POST');
          console.log('  - Data:', JSON.stringify(marcacaoData, null, 2));
          
          const response = await api.post("/correcao/marcacao", marcacaoData);
          console.log('✅ RESPOSTA DA API:', response.data);
          
          // VERIFICAÇÃO CRÍTICA: Vamos verificar se o backend está retornando a competência correta
          if (response.data && response.data.competencia) {
            console.log('🚨 COMPETÊNCIA RETORNADA PELO BACKEND:', response.data.competencia);
            console.log('🚨 COMPETÊNCIA ENVIADA:', marcacaoData.competencia);
            console.log('🚨 SÃO IGUAIS?', response.data.competencia === marcacaoData.competencia);
            
            if (response.data.competencia !== marcacaoData.competencia) {
              console.error('❌ BACKEND ALTEROU A COMPETÊNCIA!');
              console.error('  - Enviado:', marcacaoData.competencia);
              console.error('  - Retornado:', response.data.competencia);
            }
          }
          
          // Atualizar o highlight com o id_marcacao retornado pelo servidor
          if (response.data && response.data.id) {
            setHighlights(prev => prev.map(h => 
              h.id === highlight.id 
                ? { ...h, id_marcacao: response.data.id, saved: true }
                : h
            ));
            console.log(`Marcação ${highlight.id} salva com id_marcacao: ${response.data.id}`);
          }
          
          // Adicionar à lista de IDs salvos com sucesso
          savedHighlightIds.push(highlight.id);
          savedCount++;
          console.log(`Marcação ${highlight.id} salva com sucesso`);
          
        } catch (error) {
          console.error(`Erro ao salvar marcação ${highlight.id}:`, error);
          errorCount++;
        }
      }

      // Remover marcações deletadas do estado local
      if (deletedHighlightIds.length > 0) {
        console.log("🗑️ Removendo marcações deletadas do estado local:", deletedHighlightIds);
        console.log("📊 Estado atual antes da remoção:", highlights.length, "marcações");
        
        setHighlights(prev => {
          const filteredHighlights = prev.filter(h => !deletedHighlightIds.includes(h.id));
          console.log("📊 Estado após remoção:", filteredHighlights.length, "marcações");
          return filteredHighlights;
        });
        
        // Notificar componente pai sobre as marcações deletadas
        if (onHighlightDelete) {
          deletedHighlightIds.forEach(id => onHighlightDelete(id));
        }
      }

      // Atualizar o estado de todas as marcações salvas de uma vez (apenas para aquelas que não foram atualizadas individualmente)
      if (savedHighlightIds.length > 0) {
        setHighlights(prev => prev.map(h => 
          savedHighlightIds.includes(h.id) && !h.id_marcacao ? { ...h, saved: true } : h
        ));
        
        // Notificar o componente pai sobre as marcações salvas
        if (onHighlightSave) {
          onHighlightSave(savedHighlightIds);
        }
      }

      // Mensagens de sucesso e erro
      if (savedCount > 0) {
        toast.success(`${savedCount} marcação(ões) salva(s) com sucesso!`);
      }
      
      if (deletedCount > 0) {
        toast.success(`${deletedCount} marcação(ões) deletada(s) com sucesso!`);
      }
      
      if (errorCount > 0) {
        toast.error(`Erro ao processar ${errorCount} marcação(ões). Tente novamente.`);
      }

      // Recarregar a página após salvar as marcações para garantir sincronização
      if (savedCount > 0 || deletedCount > 0) {
        setTimeout(() => {
          window.location.reload();
        }, 1500); // Aguarda 1.5 segundos para mostrar as mensagens de sucesso
      }

    } catch (error) {
      console.error("Erro geral ao salvar marcações:", error);
      toast.error("Erro ao salvar marcações. Tente novamente.");
    } finally {
      setSaving(false);
    }
  };

  const updateHighlight = async (highlightId, position, content) => {
    try {
      const updatedHighlights = highlights.map(highlight => 
        highlight.id === highlightId 
          ? { ...highlight, position, content }
          : highlight
      );
      
      setHighlights(updatedHighlights);
      
      if (onHighlightUpdate) {
        onHighlightUpdate(highlightId, position, content);
      }

      toast.success("Marcação atualizada!");
    } catch (error) {
      console.error("Erro ao atualizar marcação:", error);
      toast.error("Erro ao atualizar marcação");
    }
  };

  // Função para marcar uma marcação para exclusão (soft delete)
  const markHighlightForDeletion = (highlightId) => {
    try {
      setHighlights(prev => prev.map(h => 
        h.id === highlightId 
          ? { ...h, deleted: true }
          : h
      ));
      if (onHighlightMarkDelete) {
        onHighlightMarkDelete(highlightId);
      }
      toast.info("Marcação marcada para exclusão. Clique em 'Salvar marcações' para confirmar.");
    } catch (error) {
      console.error("Erro ao marcar para exclusão:", error);
      toast.error("Erro ao marcar para exclusão");
    }
  };

  // Função para cancelar a marcação de exclusão
  const cancelHighlightDeletion = (highlightId) => {
    try {
      setHighlights(prev => prev.map(h => 
        h.id === highlightId 
          ? { ...h, deleted: false, saved: h.id_marcacao ? true : h.saved }
          : h
      ));
      if (onHighlightCancelDelete) {
        onHighlightCancelDelete(highlightId);
      }
      toast.success("Exclusão cancelada para a marcação.");
    } catch (error) {
      console.error("Erro ao cancelar exclusão:", error);
      toast.error("Erro ao cancelar exclusão");
    }
  };

  // Expor métodos para o componente pai via ref
  React.useImperativeHandle(ref, () => ({
    markHighlightForDeletion,
    cancelHighlightDeletion
  }));

  const deleteHighlight = (highlightId) => {
    try {
      console.log("🗑️ Marcando marcação para exclusão:", highlightId);
      markHighlightForDeletion(highlightId);
      console.log("✅ Marcação marcada para exclusão:", highlightId);
    } catch (error) {
      console.error("❌ Erro ao marcar marcação para exclusão:", error);
      toast.error("Erro ao marcar marcação para exclusão");
    }
  };

  if (loading) {
    return (
      <S.LoadingContainer>
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Carregando PDF...</span>
        </div>
      </S.LoadingContainer>
    );
  }

  if (!pdfUrl) {
    return (
      <S.ErrorContainer>
        <div className="alert alert-warning">
          <i className="fas fa-exclamation-triangle me-2"></i>
          PDF não encontrado para esta redação.
        </div>
      </S.ErrorContainer>
    );
  }

  return (
    <S.PDFContainer>
      <style>
        {`
          /* CSS mínimo para não interferir no posicionamento - igual ao CarregarPDF */
          .PdfHighlighter {
            width: 100% !important;
          }
          
          .PdfHighlighter canvas {
            max-width: 100% !important;
          }
          
          /* Garantir que as marcações mantenham posição correta */
          .Highlight, .AreaHighlight {
            position: absolute !important;
          }
        `}
      </style>
      
      <S.PDFHeader>
        <h5>
          <i className="fas fa-file-pdf me-2"></i>
          {user?.nivel === 'e' ? ' Redação do aluno' : ` Redação do aluno:`}
        </h5>
        <S.CompetenciaIndicator color={getColorByCompetencia(competenciaAtiva)}>
          {getEmojiByCompetencia(competenciaAtiva)}
        </S.CompetenciaIndicator>
      </S.PDFHeader>

      <S.PDFWrapper className={readOnly ? 'readonly' : ''}>
        {console.log("🖼️ Renderizando PdfLoader com URL:", pdfUrl)}
        <PdfLoader 
          url={pdfUrl} 
          beforeLoad={
            <div style={{ textAlign: 'center', padding: '50px' }}>
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Carregando PDF...</span>
              </div>
              <p className="mt-3">Carregando documento PDF...</p>
            </div>
          }
          errorMessage={
            <div style={{ textAlign: 'center', padding: '50px' }}>
              <div className="alert alert-danger">
                <i className="fas fa-exclamation-triangle me-2"></i>
                Erro ao carregar o PDF. Verifique se o arquivo existe e está acessível.
                <br />
                <small>URL: {pdfUrl}</small>
              </div>
            </div>
          }
          onError={(error) => {
            console.error("Erro no PdfLoader:", error);
            toast.error("Erro ao carregar o PDF. Tente novamente.");
          }}
        >
          {(pdfDocument) => {
            console.log("📄 PDF carregado com sucesso:", pdfDocument);
            return (
              <PdfHighlighter
              pdfDocument={pdfDocument}
              enableAreaSelection={readOnly ? false : () => true}
              pdfScaleValue="page-width"
              onScrollChange={() => {}}
              scrollRef={(scrollTo) => {
                // Função para scroll programático se necessário
                try {
                  if (scrollTo && typeof scrollTo === 'function') {
                    // Implementar scroll se necessário
                  }
                } catch (error) {
                  console.warn("Erro no scroll:", error);
                }
              }}
              onSelectionFinished={readOnly ? (
                position,
                content,
                hideTipAndSelection,
                transformSelection
              ) => (
                transformSelection(null)
              ) : (
                position,
                content,
                hideTipAndSelection,
                transformSelection
              ) => {
                // Verificar se o clique foi em um elemento de ação (botão)
                const clickedElement = document.elementFromPoint(
                  position.boundingRect.x1, 
                  position.boundingRect.y1
                );
                
                // Se clicou em um botão ou elemento de ação, não criar nova marcação
                if (clickedElement && (
                  clickedElement.closest('.popup-actions') ||
                  clickedElement.closest('.btn') ||
                  clickedElement.closest('button') ||
                  clickedElement.classList.contains('fas')
                )) {
                  console.log("🚫 Clique em elemento de ação detectado - cancelando seleção");
                  transformSelection(null);
                  return null;
                }

                try {
                  console.log('📍 Posição original do react-pdf-highlighter:', position);
                  console.log("🖱️ Seleção finalizada:", { position, content });
                  
                  return (
                    <CustomTip
                      onOpen={transformSelection}
                      onCancel={() => {
                        hideTipAndSelection();
                      }}
                      onConfirm={(comment, competenciaSelecionada) => {
                        try {
                          console.log("Confirmando marcação com comentário:", comment);
                          console.log("Competência selecionada:", competenciaSelecionada);
                          addHighlight({
                            content,
                            position,
                            comment: comment || "",
                            competencia: competenciaSelecionada || competenciaAtiva
                          });
                          hideTipAndSelection();
                        } catch (error) {
                          console.error("Erro ao confirmar marcação:", error);
                          toast.error("Erro ao salvar marcação. Tente novamente.");
                        }
                      }}
                      competenciaAtiva={competenciaAtiva}
                      onCompetenciaChange={(novaCompetencia) => {
                        // Callback para atualizar a competência ativa na página principal
                        console.log("🎯 Competência alterada no modal:", novaCompetencia);
                        if (onCompetenciaChange) {
                          onCompetenciaChange(novaCompetencia);
                        }
                      }}
                    />
                  );
                } catch (error) {
                  console.error("Erro na seleção:", error);
                  toast.error("Erro ao processar seleção. Tente novamente.");
                  hideTipAndSelection();
                  return null;
                }
              }}
              highlightTransform={(
                highlight,
                index,
                setTip,
                hideTip,
                viewportToScaled,
                screenshot,
                isScrolledTo
              ) => {
                const isTextHighlight = !Boolean(
                  highlight.content && highlight.content.image
                );

                // Correção para estabilizar posições das marcações
                const stablePosition = highlight.position ? {
                  ...highlight.position,
                  boundingRect: {
                    ...highlight.position.boundingRect,
                    // Garante que as coordenadas sejam números estáveis
                    x1: Math.round(highlight.position.boundingRect.x1 * 1000) / 1000,
                    y1: Math.round(highlight.position.boundingRect.y1 * 1000) / 1000,
                    x2: Math.round(highlight.position.boundingRect.x2 * 1000) / 1000,
                    y2: Math.round(highlight.position.boundingRect.y2 * 1000) / 1000,
                    width: Math.round(highlight.position.boundingRect.width * 1000) / 1000,
                    height: Math.round(highlight.position.boundingRect.height * 1000) / 1000,
                    top: Math.round(highlight.position.boundingRect.top * 1000) / 1000,
                    left: Math.round(highlight.position.boundingRect.left * 1000) / 1000
                  }
                } : highlight.position;

                const component = isTextHighlight ? (
                  <Highlight
                    isScrolledTo={isScrolledTo}
                    position={stablePosition}
                    comment={typeof highlight.comment === 'string' ? highlight.comment : (highlight.comment?.text || "")}
                    style={{
                      backgroundColor: getColorByCompetencia(highlight.competencia || competenciaAtiva),
                      opacity: 0.6
                    }}
                  />
                ) : (
                  <AreaHighlight
                    highlight={{...highlight, position: stablePosition}}
                    onChange={() => null}
                    style={{
                      backgroundColor: getColorByCompetencia(highlight.competencia || competenciaAtiva),
                      opacity: 0.3
                    }}
                  />
                );

                return (
                  <Popup
                    popupContent={
                      <S.PopupContent>
                        <div className="highlight-popup">
                          <div className="popup-header">
                            <span className="competencia-badge">
                              {getEmojiByCompetencia(highlight.competencia || competenciaAtiva)}
                              {(highlight.competencia || competenciaAtiva).replace('_', ' ').toUpperCase()}
                            </span>
                          </div>
                          <div className="popup-comment">
                            {typeof highlight.comment === 'string' ? highlight.comment : (highlight.comment?.text || "Sem comentário")}
                          </div>
                          {!readOnly && (
                            <div className="popup-actions">
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  deleteHighlight(highlight.id);
                                }}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </div>
                          )}
                        </div>
                      </S.PopupContent>
                    }
                    onMouseOver={(popupContent) => setTip(highlight, () => popupContent)}
                    onMouseOut={hideTip}
                    key={index}
                  >
                    {component}
                  </Popup>
                );
              }}
              highlights={highlights.filter(h => !h.deleted)}
            />
            );
          }}
        </PdfLoader>
      </S.PDFWrapper>

      {/* Botão para salvar marcações */}
      {!readOnly && (
        <S.SaveButton 
          onClick={saveAllHighlights}
          disabled={highlights.filter(h => !h.saved || h.deleted).length === 0 || saving}
        >
          {saving ? (
            <>
              <i className="fas fa-spinner fa-spin me-2"></i>
              Salvando...
            </>
          ) : (
            <>
              <i className="fas fa-save me-2"></i>
              Salvar Marcações ({highlights.filter(h => !h.saved || h.deleted).length})
            </>
          )}
        </S.SaveButton>
      )}
    </S.PDFContainer>
  );
});

export default CarregarPDFUERJ;